import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
import { KhSelect } from '@internal-libraries/kheops-ui-lib'
import { useConfigStore } from '../../../../Store/configStore'
import { useSnackStore } from '../../../../Store/snackStore'
import KhListEntryConfig from "../../../../Type/KhListEntryConfig";

interface Props {
    value?: string
    className: string
    listKeyName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClvrConfigElementObjectSelect',
  props: {
    value: { default: null },
    className: null,
    listKeyName: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: string | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, className: string, listKeyName: string }





const configStore = useConfigStore()
const snackStore = useSnackStore()
const itemList = ref<KhListEntryConfig[]>([])
const loading = ref(false)

watch(() => configStore.currentEstablishment, () => {
    loadItems()
})

onMounted(() => {
    loadItems()
})

const loadItems = () => {
    if (!props.listKeyName) return

    loading.value = true
    const groupId = configStore.currentEstablishment ?? 'global'
    
    configStore.loadItemListConfiguration(props.listKeyName, groupId, props.className).subscribe(
        result => {
            itemList.value = result.getManyData() ?? []
            loading.value = false
        },
        error => {
            snackStore.manageApiError(error)
            loading.value = false
        },
    )
}

return { __sfc: true,props, emit, configStore, snackStore, itemList, loading, loadItems, KhSelect }
}

})